import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function AutoReveal() {
  const { pathname } = useLocation();
  useEffect(() => {
    let raf = 0;
    const tick = () => {
      document.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 0) el.classList.add("is-visible");
      });
    };
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(tick);
    };
    const scan = () => {
      const els = [...document.querySelectorAll("main section")];
      document.querySelectorAll("main div").forEach((d) => {
        if (/max-w-\[\d+px\]/.test(String(d.className))) els.push(...d.children);
      });
      let i = 0;
      [...new Set(els)].forEach((el) => {
        if (
          el.classList.contains("reveal") ||
          el.closest(".reveal") ||
          el.offsetHeight < 60
        )
          return;
        el.classList.add("reveal");
        el.style.transitionDelay = `${Math.min(i++ % 4, 2) * 90}ms`;
      });
      tick();
    };
    scan();
    const t = setTimeout(scan, 900);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      clearTimeout(t);
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname]);
  return null;
}
